export class SelfScanConf {
  public id?: number;
  public division_sales_network_id: number;
  public date_start: string;
  public date_end: string;
  public description: string;
  public chk_min_num: number;
  public chk_max_num: number;
  public tx_interval: number;
  public void_qta_max: number;
  public void_val_max: number;
  public num_valid_check: number;
  public divisionSalesNetwork: string;
  public min_tx_check: number;
  public max_tx_check: number;
  public default_check_chance: number;
}

export class SelfScanConfDetail {
  public id?: number;
  public self_scanning_rules_id: number;
  public row_no: number;
  public min: number;
  public max: number;
  public step: number;
}

export class SelfScanConfDetailRow {
  public id?: number;
  public self_scanning_rules_id: number;
  public min: number;
  public max: number;
  public step: number;
}





// WEBPACK FOOTER //
// ./src/app/models/loyalty-selfScan.model.ts